import React from 'react';
import { motion } from 'framer-motion';
import { trackViewContent, trackAddToCart } from '../utils/metaPixel';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  isCheckout?: boolean;
}
export function Button({
  children,
  className = '',
  isCheckout = false,
  onClick,
  ...props
}: ButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    trackViewContent();
    if (isCheckout) {
      trackAddToCart();
      window.open('https://lucia-mujer-de-alto-valor.com/cart/48739291037919:1', '_blank');
    } else {
      const pricingSection = document.getElementById('pricing');
      if (pricingSection) {
        pricingSection.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
    if (onClick) {
      onClick(e);
    }
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`bg-burgundy text-cream font-bold py-4 px-8 rounded-none border-2 border-burgundy hover:bg-cream hover:text-burgundy transition-colors duration-300 uppercase tracking-wider text-sm md:text-base shadow-lg ${className}`} {...props} data-id="element-34">
      {children}
    </motion.button>;
}